module.exports = __webpack_public_path__ + "static/img/start1.c8459e2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/start1.png
// module id = E7S7
// module chunks = 1